import { SelectionModel } from '@angular/cdk/collections';
import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TableColumn } from './tableColumn';

import { DomSanitizer } from '@angular/platform-browser';
@Component({
    selector: 'app-mat-custom-table',
    templateUrl: './mat-custom-table.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class MatCustomTableComponent implements OnInit, OnChanges {
    @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    @Output() action?: EventEmitter<any> = new EventEmitter<any>();
    @Input() columns: Array<TableColumn>;
    @Input() dataset: Array<any> = [];
    @Input() selection?: SelectionModel<any> = new SelectionModel<any>(true, []);
    @Input() use_selection?: boolean = false;
    @Input() use_detail?: boolean = false;
    @Input() showPaginator?: boolean = true;

    dataSource: MatTableDataSource<any>;
    displayedColumns: string[] = [];
    value: string;

    constructor(private changeDetectorRefs: ChangeDetectorRef, private _sanitizer: DomSanitizer) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.dataset) {
            if (!changes.dataset.firstChange) {
                // this.dataSource = new MatTableDataSource<any>(this.dataset);
                // this.dataSource.paginator = this.paginator;
                // this.dataSource.sort = this.sort;
                this.loadDataset();
            }
        }
        this.changeDetectorRefs.detectChanges();
    }

    ngOnInit() {
        let preColumns = this.columns.map((x) => x.columnDef);

        if (this.use_selection) {
            preColumns = ['select', ...preColumns];
        }

        if (this.use_detail) {
            preColumns = [...preColumns, 'detail'];
        }

        this.displayedColumns = preColumns;
        // this.dataSource = new MatTableDataSource<any>(this.dataset);
        // this.dataSource.paginator = this.paginator;
        this.loadDataset();
    }

    loadDataset() {
        let customColumns = this.columns.filter((f) => f.columnType == 'custom');
        let data = this.dataset;
        if (customColumns.length > 0) {
            data = this.dataset.map((row) => ({
                ...row,
                ...customColumns.reduce((acc, elem) => {
                    return { ...acc, ['custom_' + elem.columnDef]: this.customRow(row, elem.columnDef, elem.columFunction) };
                }, {}),
            }));
        }

        this.dataSource = new MatTableDataSource<any>(data);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }

    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.data.length;
        return numSelected === numRows;
    }

    toggleAllRows() {
        this.isAllSelected() ? this.selection.clear() : this.dataSource.data.forEach((row) => this.selection.select(row));
    }

    selectRowMobile($event: Event, row: any) {
        if ($event) {
            $event.stopPropagation();
            if (this.use_selection) {
                this.selection.toggle(row);
            }
        }
    }

    ngAfterViewInit() {
        this.dataSource.sort = this.sort;
    }

    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }

    onTableAction(row: any): void {
        this.action.emit(row);
    }

    customRow(row: any, columnDef: string, columFunction: Function) {
        return this._sanitizer.bypassSecurityTrustHtml(columFunction(row, columnDef));
    }
}
